import SideMenu from '@/containers/side-menu/SideMenu.vue';
import CashWithdraw from '@/pages/cash-withdraw/CashWithdraw.vue';

export default {
  path: '/accounting-cash/cash-withdraw/:userId',
  name: 'CashWithdraw',
  components: {
    mainContent: CashWithdraw,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'cash-withdraw',
    },
    breadcrumb: {
      title: 'Controle de Caixa',
      paths: [{ title: 'Retirada' }],
    },
  },
};
